
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6","cy":"6","r":"6","fill":"#CD9E64"}}),_c('path',{attrs:{"d":"M6 4a1 1 0 100-2 1 1 0 000 2z","fill":"#fff"}}),_c('rect',{attrs:{"x":"5","y":"4.5","width":"2","height":"5","rx":"1","fill":"#fff"}})])
          )
        }
      }
    